import Image from 'next/image';
import { CSSProperties } from 'react';
import WithPortal from '../../lib/withPortalHOC';
import { ScreenCover } from '../ScreenCover';
import styles from './LoadingAnimation.module.scss';

type LoadingAnimationProps = {
	cover?: boolean;
	coverOpacity?: string;
	coverColor?: 'black' | 'lightBlue';
	width?: string;
	transparent?: boolean;
};

const HandGif = ( { transparent }: Pick<LoadingAnimationProps, 'transparent'> ) =>
	transparent ? (
		<video
			src='/Loading-Pig-transparent.webm'
			width={ 582 }
			height={ 582 }
			aria-label='Looping animation of coins dropping into a piggy bank'
			autoPlay
			loop
			muted
			playsInline
		/>
	) : (
		<Image
			src='/LoadingHand.gif'
			alt='Looping animation a hand morphing from rock to paper and then into a coin'
			width={ 194 }
			height={ 194 }
			unoptimized
		/>
	);

const LoadingAnimationComponent = ( {
	cover,
	coverOpacity,
	width,
	transparent,
	coverColor,
}: LoadingAnimationProps ) => {
	const screenCoverColor = coverColor === 'lightBlue' ? '#D5ECE1' : coverColor;
	const animationStyle = {
		'--loading-animation-width': width || '26rem',
		'--loading-animation-bg': 'transparent',
	} as CSSProperties;

	return (
		<>
			{ cover && (
				<ScreenCover
					coverOpacity={ coverOpacity }
					coverColor={ screenCoverColor }
					zIndex={ 14 }
				/>
			) }
			<div
				className={ `${ styles.animation } ${ cover ? styles.covered : '' }` }
				style={ animationStyle }
			>
				<HandGif transparent={ transparent } />
			</div>
		</>
	);
};

export const LoadingAnimation = WithPortal( LoadingAnimationComponent );
